import * as Factory from 'factory.ts'
import faker from 'faker'

import { VendorTypes } from '@webapp/modules/vendor/entities/enums/VendorTypeEnum'
import { PaymentTermApiModelStub } from './PaymentTermApiModel.stub'
import { ShippingMethodApiModelStub } from './ShippingMethodApiModel.stub'
import { ShippingTermApiModelStub } from './ShippingTermApiModel.stub'
import { type VendorApiModel } from '../VendorApiModel'

export const VendorApiModelStub = Factory.Sync.makeFactory<VendorApiModel>({
  id: Factory.each(() => faker.random.number()),
  name: Factory.each(() => faker.company.companyName()),
  active: true,
  addressLineOne: Factory.each(() => faker.address.streetAddress()),
  addressLineTwo: Factory.each(() => faker.address.streetAddress()),
  postalCode: Factory.each(() => faker.address.zipCode()),
  city: Factory.each(() => faker.address.city()),
  state_province: Factory.each(() => faker.address.state()),
  country: Factory.each(() => faker.address.country()),
  phoneOne: Factory.each(() => faker.phone.phoneNumber()),
  phoneTwo: '',
  fax: '',
  email: [faker.internet.email()],
  email_configurations: null,
  comments: faker.lorem.sentence(),
  contact: faker.name.findName(),
  url: faker.internet.url(),
  external_id: '',
  dateModified: faker.date.past(10).toISOString(),
  currency: faker.random.number(),
  payment_term_ref: PaymentTermApiModelStub.build(),
  shipping_term_ref: ShippingTermApiModelStub.build(),
  shipping_method_ref: ShippingMethodApiModelStub.build(),
  po_pdf_labels: 'Standard',
  is_auto_email_po_enabled: false,
  default_payment_method: null,
  payment_methods: [],
  type: VendorTypes.PREFERRED,
  tax: null,
})
